const STORAGE_KEY = 'placepledge.publicPledgeTargets.v1';

const readTargets = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
  } catch (error) {
    console.warn('Unable to read public pledge targets:', error);
    return {};
  }
};

const writeTargets = (targets) => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(targets));
};

const bytesToHex = (bytes) => {
  return Array.from(bytes)
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
};

const rightRotate = (value, amount) => {
  return (value >>> amount) | (value << (32 - amount));
};

const encodeUtf8 = (value) => {
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(value);
  }

  const encoded = unescape(encodeURIComponent(String(value)));
  const bytes = new Uint8Array(encoded.length);

  for (let index = 0; index < encoded.length; index += 1) {
    bytes[index] = encoded.charCodeAt(index);
  }

  return bytes;
};

const sha256Fallback = (bytes) => {
  const constants = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
    0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
    0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
    0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
    0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
    0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];
  const hash = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  const paddedLength = Math.ceil((bytes.length + 9) / 64) * 64;
  const padded = new Uint8Array(paddedLength);
  const words = new Uint32Array(64);

  padded.set(bytes);
  padded[bytes.length] = 0x80;

  const bitLength = bytes.length * 8;
  const bitLengthHigh = Math.floor(bitLength / 0x100000000);
  const bitLengthLow = bitLength >>> 0;

  padded[paddedLength - 8] = (bitLengthHigh >>> 24) & 0xff;
  padded[paddedLength - 7] = (bitLengthHigh >>> 16) & 0xff;
  padded[paddedLength - 6] = (bitLengthHigh >>> 8) & 0xff;
  padded[paddedLength - 5] = bitLengthHigh & 0xff;
  padded[paddedLength - 4] = (bitLengthLow >>> 24) & 0xff;
  padded[paddedLength - 3] = (bitLengthLow >>> 16) & 0xff;
  padded[paddedLength - 2] = (bitLengthLow >>> 8) & 0xff;
  padded[paddedLength - 1] = bitLengthLow & 0xff;

  for (let offset = 0; offset < padded.length; offset += 64) {
    for (let index = 0; index < 16; index += 1) {
      const wordOffset = offset + index * 4;
      words[index] = (
        (padded[wordOffset] << 24) |
        (padded[wordOffset + 1] << 16) |
        (padded[wordOffset + 2] << 8) |
        padded[wordOffset + 3]
      ) >>> 0;
    }

    for (let index = 16; index < 64; index += 1) {
      const s0 = rightRotate(words[index - 15], 7) ^ rightRotate(words[index - 15], 18) ^ (words[index - 15] >>> 3);
      const s1 = rightRotate(words[index - 2], 17) ^ rightRotate(words[index - 2], 19) ^ (words[index - 2] >>> 10);
      words[index] = (words[index - 16] + s0 + words[index - 7] + s1) >>> 0;
    }

    let [a, b, c, d, e, f, g, h] = hash;

    for (let index = 0; index < 64; index += 1) {
      const s1 = rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25);
      const ch = (e & f) ^ (~e & g);
      const temp1 = (h + s1 + ch + constants[index] + words[index]) >>> 0;
      const s0 = rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22);
      const maj = (a & b) ^ (a & c) ^ (b & c);
      const temp2 = (s0 + maj) >>> 0;

      h = g;
      g = f;
      f = e;
      e = (d + temp1) >>> 0;
      d = c;
      c = b;
      b = a;
      a = (temp1 + temp2) >>> 0;
    }

    hash[0] = (hash[0] + a) >>> 0;
    hash[1] = (hash[1] + b) >>> 0;
    hash[2] = (hash[2] + c) >>> 0;
    hash[3] = (hash[3] + d) >>> 0;
    hash[4] = (hash[4] + e) >>> 0;
    hash[5] = (hash[5] + f) >>> 0;
    hash[6] = (hash[6] + g) >>> 0;
    hash[7] = (hash[7] + h) >>> 0;
  }

  const digest = new Uint8Array(32);

  hash.forEach((value, index) => {
    const offset = index * 4;
    digest[offset] = (value >>> 24) & 0xff;
    digest[offset + 1] = (value >>> 16) & 0xff;
    digest[offset + 2] = (value >>> 8) & 0xff;
    digest[offset + 3] = value & 0xff;
  });

  return digest;
};

export const createFulfillmentSecret = () => {
  const bytes = new Uint8Array(32);

  if (!window.crypto?.getRandomValues) {
    throw new Error('Secure random values are not available in this browser');
  }

  window.crypto.getRandomValues(bytes);

  return bytesToHex(bytes);
};

export const hashFulfillmentSecret = async (secret) => {
  const data = encodeUtf8(secret);

  if (window.crypto?.subtle?.digest) {
    const digest = await window.crypto.subtle.digest('SHA-256', data);

    return bytesToHex(new Uint8Array(digest));
  }

  return bytesToHex(sha256Fallback(data));
};

export const savePublicPledgeTarget = (target) => {
  if (!target?.pledgeId) {
    throw new Error('pledgeId is required');
  }

  const targets = readTargets();
  targets[target.pledgeId] = {
    pledgeId: target.pledgeId,
    targetLat: target.targetLat,
    targetLng: target.targetLng,
    radiusFeet: target.radiusFeet,
    radiusUnit: target.radiusUnit || 'feet',
    displayLabel: target.displayLabel || 'Private destination',
    fulfillmentSecret: target.fulfillmentSecret
  };

  writeTargets(targets);
};

export const loadPublicPledgeTarget = (pledgeId) => {
  if (!pledgeId) {
    return null;
  }

  return readTargets()[pledgeId] || null;
};

export const deletePublicPledgeTarget = (pledgeId) => {
  const targets = readTargets();
  delete targets[pledgeId];
  writeTargets(targets);
};
